import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import uuid from 'uuid/v4';
import { encode as _encode, decode as _decode } from './encoder';
import { getEnv } from './env';
var packageVersion = "6.1.3" || '';
var originParamName = 'atlOrigin';
var originVersioningAttributes = {
  originLibrary: "origin-tracing.js@".concat(packageVersion)
};
var OriginTracer = /*#__PURE__*/function () {
  function OriginTracer(_ref) {
    var _ref$id = _ref.id,
      id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id,
      product = _ref.product,
      _ref$dangerouslySkipV = _ref.dangerouslySkipValidation,
      dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
    _classCallCheck(this, OriginTracer);
    this.id = id;
    this.product = product;
    if (!dangerouslySkipValidation) {
      this.validate();
    }
  }
  _createClass(OriginTracer, [{
    key: "encode",
    value: function encode() {
      return _encode({
        id: this.id,
        product: this.product
      });
    }
  }, {
    key: "addToUrl",
    value: function addToUrl(url) {
      var _this = this;
      return replaceQuery(url, function (originalQueryString) {
        var params = new (getEnv().URLSearchParams)(originalQueryString);
        params.set(originParamName, _this.encode());
        return params.toString();
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return false;
    }
  }, {
    key: "isMalformed",
    value: function isMalformed() {
      return !this.isEmpty() && !this.isValid();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return true;
    }
  }, {
    key: "toAnalyticsAttributes",
    value: function toAnalyticsAttributes() {
      var _objectSpread2;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$transformValue = _ref2.transformValue,
        transformValue = _ref2$transformValue === void 0 ? function (v) {
          return v === null ? undefined : v;
        } : _ref2$transformValue,
        _ref2$hasGeneratedId = _ref2.hasGeneratedId,
        hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
      // `originIdGenerated` should be used in analytic events that generated this originId.
      // Subsequent events should use `originId`.
      // No two events should have the same value of originIdGenerated.
      var originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
      return _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, originIdProp, transformValue(this.id)), _defineProperty(_objectSpread2, "originProduct", transformValue(this.product)), _objectSpread2), originVersioningAttributes);
    }
  }, {
    key: "validate",
    value: function validate() {
      if (!OriginTracer.isValidId(this.id)) {
        throw new TypeError('Invalid Origin id');
      }
      if (!OriginTracer.isValidProduct(this.product)) {
        throw new TypeError('Missing/invalid Origin product');
      }
    }
  }], [{
    key: "isValidId",
    value: function isValidId(value) {
      return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
  }, {
    key: "isValidProduct",
    value: function isValidProduct(value) {
      return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
  }, {
    key: "generateId",
    value: function generateId() {
      var id = uuid();

      // Dash positions are fixed so they don't add to uniqueness.
      // Remove them to save space in the encoded form.
      return id.replace(/-/g, '');
    }
  }, {
    key: "createEmpty",
    value: function createEmpty() {
      return new EmptyOriginTracer();
    }
  }, {
    key: "createMalformed",
    value: function createMalformed() {
      return new MalformedOriginTracer();
    }
  }, {
    key: "fromUrl",
    value: function fromUrl(url) {
      var params = new (getEnv().URLSearchParams)();
      replaceQuery(url, function (queryString) {
        params = new (getEnv().URLSearchParams)(queryString);
      });
      return OriginTracer.fromEncoded(params.get(originParamName));
    }
  }, {
    key: "fromEncoded",
    value: function fromEncoded(encoded) {
      if (!encoded) {
        return OriginTracer.createEmpty();
      }
      try {
        return OriginTracer.decode(encoded);
      } catch (e) {
        return OriginTracer.createMalformed();
      }
    }
  }, {
    key: "removeFromUrl",
    value: function removeFromUrl(url) {
      return replaceQuery(url, function (queryString) {
        var params = new (getEnv().URLSearchParams)(queryString);
        params.delete(originParamName);
        return params.toString();
      });
    }
  }, {
    key: "decode",
    value: function decode(encodedOrigin) {
      var originData = _decode(encodedOrigin);
      return new OriginTracer(originData);
    }
  }]);
  return OriginTracer;
}();
export { OriginTracer as default };
var EmptyOriginTracer = /*#__PURE__*/function (_OriginTracer) {
  _inherits(EmptyOriginTracer, _OriginTracer);
  var _super = _createSuper(EmptyOriginTracer);
  function EmptyOriginTracer() {
    _classCallCheck(this, EmptyOriginTracer);
    return _super.call(this, {
      id: null,
      product: null,
      dangerouslySkipValidation: true
    });
  }
  _createClass(EmptyOriginTracer, [{
    key: "isValid",
    value: function isValid() {
      return false;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return true;
    }
  }, {
    key: "toAnalyticsAttributes",
    value: function toAnalyticsAttributes() {
      return _objectSpread({}, originVersioningAttributes);
    }
  }]);
  return EmptyOriginTracer;
}(OriginTracer);
var MalformedOriginTracer = /*#__PURE__*/function (_OriginTracer2) {
  _inherits(MalformedOriginTracer, _OriginTracer2);
  var _super2 = _createSuper(MalformedOriginTracer);
  function MalformedOriginTracer() {
    _classCallCheck(this, MalformedOriginTracer);
    return _super2.call(this, {
      id: null,
      product: null,
      dangerouslySkipValidation: true
    });
  }
  _createClass(MalformedOriginTracer, [{
    key: "isValid",
    value: function isValid() {
      return false;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return false;
    }
  }, {
    key: "toAnalyticsAttributes",
    value: function toAnalyticsAttributes() {
      return _objectSpread({
        originMalformed: true
      }, originVersioningAttributes);
    }
  }]);
  return MalformedOriginTracer;
}(OriginTracer);
function replaceQuery(url, replacer) {
  var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;

  // If we get passed window.location, we don't want to call window.location.replace()
  var urlString = String(url);
  return urlString.replace(urlWithQueryStringRegex, function (wholeMatch, beforeQuery, queryString, afterQuery) {
    var newQueryString = replacer(queryString);
    if (newQueryString) {
      newQueryString = "?".concat(newQueryString);
    }
    return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
  });
}